import React, { useContext } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import { Container } from "reactstrap";
import AdminFooter from "../../components/Footers/AdminFooter";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./Admin.css";
import { routesOffice } from "../../routes.js";
import { AuthContext } from "../../context/AuthContext";
import LogoutTimer from "../../components/LogoutTimer/LogoutTimer";

const Admin = (props: any) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document && document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
    if (mainContent && mainContent.current) {
      //@ts-ignore
      mainContent.current.scrollTop = 0;
    }
  }, [location]);

  const getRoutes = (routes: any) => {
    return routes.map((prop: any, key: number) => {
      if (prop.layout === "/admin") {
        const relativePath = prop.path.startsWith("/")
          ? prop.path.slice(1)
          : prop.path;
        return (
          // @ts-ignore
          <Route path={relativePath} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <>
      <LogoutTimer />
      {!location.pathname.startsWith("/admin/sign-document") && (
        <Sidebar
          {...props}
          routes={routesOffice}
          logo={{
            innerLink: "/admin/index",
            imgSrc: require("../../assets/img/brand/logoendocpng.png"),
            imgAlt: "enDoc",
          }}
        />
      )}
      <div className="main-content" ref={mainContent}>
        {/* react-router-dom v6: basename — @types/react-router-dom v5 omits it */}
        {/* @ts-expect-error */}
        <Routes basename="/admin">
          {getRoutes(routesOffice)}
          <Route
            path="*"
            element={<Navigate to="/admin/index" replace />}
          />
        </Routes>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default Admin;
